var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "policyModal",
      staticClass: "modal fade",
      attrs: {
        id: "policyModal",
        tabindex: "-1",
        role: "dialog",
        "aria-labelledby": "exampleModalCenterTitle",
      },
    },
    [
      _vm.language === "en"
        ? _c(
            "div",
            {
              staticClass: "modal-dialog go-modal-policy",
              staticStyle: { overflow: "hidden" },
            },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("div", { staticClass: "modal-title" }, [
                    _vm._v("Privacy Policy"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn go-btn-icon close",
                      attrs: {
                        id: "buttonClosePopupPolicy",
                        type: "button",
                        "data-dismiss": "modal",
                      },
                      on: { click: _vm.handleCloseElement },
                    },
                    [_c("i", { staticClass: "go-icon-24 go-icon-close" })]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c(
                    "div",
                    { staticClass: "go-policy-content-wrap" },
                    [
                      _c(
                        "vue-custom-scrollbar",
                        {
                          staticClass:
                            "go-policy-content-inner overflow-y-scroll customScroll csScrollPosition ps",
                          attrs: { settings: _vm.scrollSettings },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                overflow: "hidden",
                                width: "auto",
                                height: "auto",
                              },
                            },
                            [
                              _c("div", { staticClass: "go-section" }, [
                                _c("div", { staticClass: "go-shortcut-box" }, [
                                  _c("strong", [_vm._v("Table of Contents")]),
                                  _vm._v(" "),
                                  _c(
                                    "ol",
                                    { staticClass: "go-shortcut-list" },
                                    [
                                      _c(
                                        "li",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.scrollToSection(
                                                "pp-s1-en"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("a", [
                                            _vm._v(
                                              "Collection of your Personal Information "
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.scrollToSection(
                                                "pp-s2-en"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("a", [
                                            _vm._v(
                                              "Sharing Information with Third Parties"
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.scrollToSection(
                                                "pp-s3-en"
                                              )
                                            },
                                          },
                                        },
                                        [_c("a", [_vm._v("Right to Deletion")])]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.scrollToSection(
                                                "pp-s4-en"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("a", [
                                            _vm._v("Children Under Thirteen"),
                                          ]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.scrollToSection(
                                                "pp-s5-en"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("a", [
                                            _vm._v(
                                              "Disconnecting your Goover Account from Third Party Websites"
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.scrollToSection(
                                                "pp-s6-en"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("a", [
                                            _vm._v("E-mail Communications"),
                                          ]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.scrollToSection(
                                                "pp-s7-en"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("a", [
                                            _vm._v("Changes to this Statement"),
                                          ]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.scrollToSection(
                                                "pp-s8-en"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("a", [
                                            _vm._v("Contact Information"),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "\n                  Protecting your private information is our priority. This Statement of Privacy applies to goover.ai, and Goover and\n                  governs data collection and usage. For the purposes of this Privacy Policy, unless otherwise noted, all references to\n                  Goover include https://goover.ai/ and Goover. The Goover application is a knowledge assistant application. By using the\n                  Goover application, you consent to the data practices described in this statement.\n                "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "go-section",
                                  attrs: { id: "pp-s1-en" },
                                },
                                [
                                  _c("h2", [
                                    _vm._v(
                                      "Collection of your Personal Information"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                  We do not collect any personal information about you unless you voluntarily provide it to us. However, you may be\n                  required to provide certain personal information to us when you elect to use certain products or services.\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [_vm._v("These may include:")]),
                                  _vm._v(" "),
                                  _c(
                                    "ul",
                                    { staticClass: "list-style-lowerAlpha" },
                                    [
                                      _c("li", [
                                        _vm._v("registering for an account;"),
                                      ]),
                                      _vm._v(" "),
                                      _c("li", [
                                        _vm._v(
                                          "contest sponsored by us or one of our partners;"
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("li", [
                                        _vm._v(
                                          "signing up for special offers from selected third parties;"
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("li", [
                                        _vm._v("sending us an email message;"),
                                      ]),
                                      _vm._v(" "),
                                      _c("li", [
                                        _vm._v(
                                          "submitting your credit card or other payment information when ordering and purchasing products and services."
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                  Especially, we will use your information for, but not limited to, communicating with you in relation to services and/or\n                  products you have requested from us. We also may gather additional personal or non-personal information in the future.\n                "
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "go-section",
                                  attrs: { id: "pp-s2-en" },
                                },
                                [
                                  _c("h2", [
                                    _vm._v(
                                      "Sharing Information with Third Parties"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "Goover does not sell, rent or lease its customer lists to third parties."
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                  Goover may share data with trusted partners to help perform statistical analysis, send you email or postal mail, provide\n                  customer support, or arrange for deliveries. All such third parties are prohibited from using your personal information\n                  except to provide these services to Goover, and they are required to maintain the confidentiality of your information.\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                  Goover may disclose your personal information, without notice, if required to do so by law or in the good faith belief\n                  that such action is necessary to:\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "ul",
                                    { staticClass: "list-style-lowerAlpha" },
                                    [
                                      _c("li", [
                                        _vm._v(
                                          "conform to the edicts of the law or comply with legal process served on Goover or the site;"
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("li", [
                                        _vm._v(
                                          "protect and defend the rights or property of Goover; and/or"
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("li", [
                                        _vm._v(
                                          "act under exigent circumstances to protect the personal safety of users of Goover, or the public."
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "go-section",
                                  attrs: { id: "pp-s3-en" },
                                },
                                [
                                  _c("h2", [_vm._v("Right to Deletion")]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "Subject to certain exceptions set out below, on receipt of a verifiable request from you, we will:"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("ul", { staticClass: "list-style-disc" }, [
                                    _c("li", [
                                      _vm._v(
                                        "Delete your personal information from our records; and"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _vm._v(
                                        "Direct any service providers to delete your personal information from their records."
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                  Please note that we may not be able to comply with requests to delete your personal information if it is necessary to:\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("ul", { staticClass: "list-style-disc" }, [
                                    _c("li", [
                                      _vm._v(
                                        "\n                    Complete the transaction for which the personal information was collected, fulfill the terms of a written warranty or\n                    product recall conducted in accordance with federal law, provide a good or service requested by you, or reasonably\n                    anticipated within the context of our ongoing business relationship with you, or otherwise perform a contract between\n                    you and us;\n                  "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _vm._v(
                                        "\n                    Detect security incidents, protect against malicious, deceptive, fraudulent, or illegal activity; or prosecute those\n                    responsible for that activity;\n                  "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _vm._v(
                                        "Debug to identify and repair errors that impair existing intended functionality;"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _vm._v(
                                        "\n                    Exercise free speech, ensure the right of another consumer to exercise his or her right of free speech, or exercise\n                    another right provided for by law;\n                  "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _vm._v(
                                        "Comply with the California Electronic Communications Privacy Act;"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _vm._v(
                                        "\n                    Engage in public or peer-reviewed scientific, historical, or statistical research in the public interest that adheres\n                    to all other applicable ethics and privacy laws, when our deletion of the information is likely to render impossible\n                    or seriously impair the achievement of such research, provided we have obtained your informed consent;\n                  "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _vm._v(
                                        "\n                    Enable solely internal uses that are reasonably aligned with your expectations based on your relationship with us;\n                  "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _vm._v(
                                        "Comply with an existing legal obligation; or"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _vm._v(
                                        "\n                    Otherwise use your personal information, internally, in a lawful manner that is compatible with the context in which\n                    you provided the information.\n                  "
                                      ),
                                    ]),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "go-section",
                                  attrs: { id: "pp-s4-en" },
                                },
                                [
                                  _c("h2", [_vm._v("Children Under Thirteen")]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                  Goover does not knowingly collect personally identifiable information from children under the age of thirteen. If you\n                  are under the age of thirteen, you must ask your parent or guardian for permission to use this application.\n                "
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "go-section",
                                  attrs: { id: "pp-s5-en" },
                                },
                                [
                                  _c("h2", [
                                    _vm._v(
                                      "Disconnecting your Goover Account from Third Party Websites"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                  You will be able to connect your Goover account to third party accounts. BY CONNECTING YOUR GOOVER ACCOUNT TO YOUR THIRD\n                  PARTY ACCOUNT, YOU ACKNOWLEDGE AND AGREE THAT YOU ARE CONSENTING TO THE CONTINUOUS RELEASE OF INFORMATION ABOUT YOU TO\n                  OTHERS (IN ACCORDANCE WITH YOUR PRIVACY SETTINGS ON THOSE THIRD PARTY SITES). IF YOU DO NOT WANT INFORMATION ABOUT YOU,\n                  INCLUDING PERSONALLY IDENTIFYING INFORMATION, TO BE SHARED IN THIS MANNER, DO NOT USE THIS FEATURE. You may disconnect\n                  your account from a third party account at any time. Users will be able to log out their access through Microsoft Teams\n                  app.\n                "
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "go-section",
                                  attrs: { id: "pp-s6-en" },
                                },
                                [
                                  _c("h2", [_vm._v("E-mail Communications")]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                  From time to time, Goover may contact you via email for the purpose of providing announcements, promotional offers,\n                  alerts, confirmations, surveys, and/or other general communication. In order to improve our Services, we may receive a\n                  notification when you open an email from Goover or click on a link therein.\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                  If you would like to stop receiving marketing or promotional communications via email from Goover, you may opt out of\n                  such communications by clicking on the UNSUBSCRIBE button.\n                "
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "go-section",
                                  attrs: { id: "pp-s7-en" },
                                },
                                [
                                  _c("h2", [
                                    _vm._v("Changes to this Statement"),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                  Goover reserves the right to change this Privacy Policy from time to time. We will notify you about significant changes\n                  in the way we treat personal information by sending a notice to the primary email address specified in your account, by\n                  placing a prominent notice on our application, and/or by updating any privacy information. Your continued use of the\n                  application and/or Services available after such modifications will constitute your:\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "ul",
                                    { staticClass: "list-style-lowerAlpha" },
                                    [
                                      _c("li", [
                                        _vm._v(
                                          "acknowledgment of the modified Privacy Policy; and"
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("li", [
                                        _vm._v(
                                          "agreement to abide and be bound by that Policy."
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "go-section",
                                  attrs: { id: "pp-s8-en" },
                                },
                                [
                                  _c("h2", [_vm._v("Contact Information")]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                  Goover welcomes your questions or comments regarding this Statement of Privacy. If you believe that Goover has not\n                  adhered to this Statement, please contact Goover at:\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "go-table-wrap" }, [
                                    _c("table", { staticClass: "go-table" }, [
                                      _c("tbody", [
                                        _c("tr", [
                                          _c("th", [_vm._v("Email Address")]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _c("a", [
                                              _vm._v("contact@goover.ai"),
                                            ]),
                                          ]),
                                        ]),
                                        _vm._v(" "),
                                        _c("tr", [
                                          _c("th", [_vm._v("Effective Date")]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              "Effective as of December 05, 2022"
                                            ),
                                          ]),
                                        ]),
                                      ]),
                                    ]),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn go-btn-default",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: { click: _vm.handleConfirm },
                    },
                    [_vm._v("Confirm")]
                  ),
                ]),
              ]),
            ]
          )
        : _c(
            "div",
            {
              staticClass: "modal-dialog go-modal-policy",
              staticStyle: { overflow: "hidden" },
            },
            [
              _c("div", { staticClass: "modal-content" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c(
                    "div",
                    { staticClass: "go-policy-content-wrap" },
                    [
                      _c(
                        "vue-custom-scrollbar",
                        {
                          staticClass:
                            "go-policy-content-inner overflow-y-scroll customScroll csScrollPosition ps",
                          attrs: { settings: _vm.scrollSettings },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                overflow: "hidden",
                                width: "auto",
                                height: "auto",
                                "word-break": "keep-all",
                              },
                            },
                            [
                              _c("div", { staticClass: "go-section" }, [
                                _c("div", { staticClass: "go-shortcut-box" }, [
                                  _c("strong", [_vm._v("목차")]),
                                  _vm._v(" "),
                                  _c(
                                    "ol",
                                    { staticClass: "go-shortcut-list" },
                                    [
                                      _c(
                                        "li",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.scrollToSection(
                                                "pp-s1-ko"
                                              )
                                            },
                                          },
                                        },
                                        [_c("a", [_vm._v("개인 정보 수집")])]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.scrollToSection(
                                                "pp-s2-ko"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("a", [
                                            _vm._v("제 3자와의 정보 공유"),
                                          ]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.scrollToSection(
                                                "pp-s3-ko"
                                              )
                                            },
                                          },
                                        },
                                        [_c("a", [_vm._v("삭제 권리")])]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.scrollToSection(
                                                "pp-s4-ko"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("a", [
                                            _vm._v("13세 미만의 어린이"),
                                          ]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.scrollToSection(
                                                "pp-s5-ko"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("a", [
                                            _vm._v(
                                              "제 3자 웹사이트와의 Goover 계정 연결 해제"
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.scrollToSection(
                                                "pp-s6-ko"
                                              )
                                            },
                                          },
                                        },
                                        [_c("a", [_vm._v("이메일 통신")])]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.scrollToSection(
                                                "pp-s7-ko"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("a", [
                                            _vm._v("이 성명서의 변경 사항"),
                                          ]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.scrollToSection(
                                                "pp-s8-ko"
                                              )
                                            },
                                          },
                                        },
                                        [_c("a", [_vm._v("연락처 정보")])]
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "\n                  귀하의 개인 정보를 보호하는 것이 우리의 최우선 과제입니다. 이 개인정보 보호 정책은 goover.ai와 Goover에 적용되며 데이터\n                  수집 및 사용을 규율합니다. 이 개인정보 보호 정책의 목적으로, 별도로 명시되지 않는 한, Goover의 모든 참조는\n                  https://goover.ai/ 및 Goover를 포함합니다. Goover 애플리케이션은 지식 보조 애플리케이션입니다. Goover 애플리케이션을\n                  사용함으로써 귀하는 이 성명서에서 설명하는 데이터 처리 방식에 동의합니다.\n                "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "go-section",
                                  attrs: { id: "pp-s1-ko" },
                                },
                                [
                                  _c("h2", [_vm._v("개인 정보 수집")]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                  귀하가 자발적으로 제공하지 않는 한, 귀하에 관한 개인 정보를 수집하지 않습니다. 그러나 특정 제품이나 서비스를 사용하도록\n                  선택하실 때, 귀하가 일부 개인 정보를 제공해야 할 수 있습니다.\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "이러한 정보는 다음을 포함할 수 있습니다."
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "ul",
                                    { staticClass: "list-style-lowerAlpha" },
                                    [
                                      _c("li", [_vm._v("계정 등록;")]),
                                      _vm._v(" "),
                                      _c("li", [
                                        _vm._v(
                                          "우리 또는 우리의 파트너가 주최한 공모전;"
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("li", [
                                        _vm._v(
                                          "선정된 제3자로부터 특별한 제안에 등록;"
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("li", [
                                        _vm._v("이메일 메시지 보내기;"),
                                      ]),
                                      _vm._v(" "),
                                      _c("li", [
                                        _vm._v(
                                          "제품 및 서비스 주문 및 구매 시 신용 카드 또는 기타 결제 정보 제출"
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                  특히, 귀하가 요청한 서비스 및/또는 제품과 관련하여 귀하와 의사소통하는 등의 목적으로 귀하의 정보를 사용할 것입니다. 또한\n                  앞으로 개인 정보 또는 비개인 정보를 추가로 수집할 수도 있습니다.\n                "
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "go-section",
                                  attrs: { id: "pp-s2-ko" },
                                },
                                [
                                  _c("h2", [_vm._v("제 3자와의 정보 공유")]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "Goover는 고객 명단을 제 3자에게 판매, 혹은 대여를 하지 않습니다."
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                  Goover는 통계 분석을 수행하거나 이메일이나 우편을 보내고, 고객 지원을 제공하거나, 배송을 조정하기 위해 신뢰할 수 있는\n                  파트너와 데이터를 공유할 수 있습니다. 이러한 제 3자들은 Goover에 이러한 서비스를 제공하기 위해 귀하의 개인 정보를\n                  사용하는 것 외에는 금지되며, 귀하의 정보의 기밀성을 유지해야 합니다.\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "법률에 의하거나 선의로 믿음에 따라 필요한 경우 Goover는 사전 통지 없이 귀하의 개인 정보를 공개할 수 있습니다. 이는"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "ul",
                                    { staticClass: "list-style-lowerAlpha" },
                                    [
                                      _c("li", [
                                        _vm._v(
                                          "법률의 규정에 따르거나 Goover 또는 사이트에 제출된 법적 절차를 준수하기 위한 경우"
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("li", [
                                        _vm._v(
                                          "Goover의 권리 또는 재산을 보호하고 방어하기 위한 경우; 및/또"
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("li", [
                                        _vm._v(
                                          "긴박한 상황에서 Goover 사용자 또는 일반 대중의 개인 안전을 보호하기 위한 경우에 해당합니다."
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "go-section",
                                  attrs: { id: "pp-s3-ko" },
                                },
                                [
                                  _c("h2", [_vm._v("삭제 권리")]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "아래에 명시된 일부 예외 사항을 제외하고, 귀하의 확인 가능한 요청을 받으면, 저희는 다음을 수행할 것입니다."
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("ul", { staticClass: "list-style-disc" }, [
                                    _c("li", [
                                      _vm._v(
                                        "귀하의 개인 정보를 저희 기록에서 삭제하고;"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _vm._v(
                                        "서비스 제공 업체에게 귀하의 개인 정보를 기록에서 삭제하도록 지시합니다."
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "다음과 같은 경우 귀하의 개인 정보를 삭제하는 요청을 이행할 수 없다는 점을 참고하시기 바랍니다."
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("ul", { staticClass: "list-style-disc" }, [
                                    _c("li", [
                                      _vm._v(
                                        "\n                    개인 정보가 수집된 거래를 완료하거나, 연방법에 따른 서면 보증이나 제품 리콜 조건을 이행하거나, 귀하가 요청한 제품이나\n                    서비스를 제공하거나, 귀하와 저희 사이의 계약을 이행하기 위해 합당하게 예상되는 귀하와 저희의 지속적인 사업 관계 내에서\n                    필요한 경우;\n                  "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _vm._v(
                                        "\n                    보안 사건을 탐지하고, 악의적이거나 기만적인, 사기적인 또는 불법 활동에 대해 보호하거나, 이러한 활동에 대한 책임을 물을\n                    수 있는 사람을 기소하기 위한 경우;\n                  "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _vm._v(
                                        "기존 의도된 기능을 손상시키는 오류를 식별하고 수정하기 위해 디버그하는 경우;"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _vm._v(
                                        "\n                    자유로운 언론행사를 하거나, 다른 소비자가 그의 또는 그녀의 자유로운 언론행사권을 행사하도록 보장하거나, 법으로 규정된\n                    다른 권리를 행사하는 경우;\n                  "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _vm._v(
                                        "캘리포니아 전자 통신 개인정보 보호법에 따라 준수하는 경우;"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _vm._v(
                                        "\n                    모든 기타 적용 가능한 윤리 및 개인 정보 보호법에 부합하는 공익에 있는 과학적, 역사적 또는 통계적 연구에 대한 공개 또는\n                    동료 평가를 받는 경우, 정보 삭제가 이러한 연구를 불가능하게 하거나 심각하게 저해할 가능성이 있는 경우, 전제조건으로\n                    귀하의 동의를 얻었을 때;\n                  "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _vm._v(
                                        "귀하와의 관계를 기반으로 합리적으로 기대할 수 있는 내부 사용만을 목적으로 하는 경우;"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _vm._v("기존 법적 의무를 준수하는 경우;"),
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _vm._v(
                                        "또는 귀하가 제공한 맥락과 호환되는 합법적인 방법으로 귀하의 개인 정보를 내부적으로 사용하는 경우입니다."
                                      ),
                                    ]),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "go-section",
                                  attrs: { id: "pp-s4-ko" },
                                },
                                [
                                  _c("h2", [_vm._v("13세 미만의 어린이")]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                  Goover는 실수로 13세 미만의 어린이로부터 개인 정보를 수집하지 않습니다. 만약 귀하가 13세 미만이라면, 이 애플리케이션을\n                  사용하기 전에 부모 또는 법정 대리인의 허락을 받아야 합니다.\n                "
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "go-section",
                                  attrs: { id: "pp-s5-ko" },
                                },
                                [
                                  _c("h2", [
                                    _vm._v(
                                      "제 3자 웹사이트와의 Goover 계정 연결 해제"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                  귀하는 Goover 계정을 제 3자 계정과 연결할 수 있습니다. GOOVER 계정을 귀하의 제 3자 계정과 연결함으로써 귀하는 계속해서\n                  귀하에 대한 정보가 다른 사람들에게 공개됨을 동의하며 (제 3자 사이트의 개인정보 설정에 따라), 이러한 정보를 공유하지\n                  않기를 원하지 않는 경우 이 기능을 사용하지 마십시오. 귀하는 언제든지 제 3자 계정에서 계정 연결을 해제할 수 있습니다.\n                  사용자는 Microsoft Teams 앱을 통해 로그아웃할 수 있습니다.\n                "
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "go-section",
                                  attrs: { id: "pp-s6-ko" },
                                },
                                [
                                  _c("h2", [_vm._v("이메일 통신")]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                  가끔, Goover는 공지, 프로모션 제안, 경고, 확인, 설문 조사 및/또는 일반적인 커뮤니케이션을 제공하기 위해 귀하에게\n                  이메일을 보낼 수 있습니다. 서비스 개선을 위해, Goover에서 보낸 이메일을 열거나 이메일 내의 링크를 클릭할 때 알림을 받을\n                  수 있습니다.\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                  Goover로부터 마케팅 또는 프로모션 관련 이메일을 받는 것을 원하지 않는 경우, UNSUBSCRIBE 버튼을 클릭하여 이러한\n                  커뮤니케이션에서 탈퇴할 수 있습니다.\n                "
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "go-section",
                                  attrs: { id: "pp-s7-ko" },
                                },
                                [
                                  _c("h2", [_vm._v("이 성명서의 변경 사항")]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                  Goover는 시간에 따라 개인정보 보호 정책을 변경할 권리를 보유합니다. 개인 정보 처리 방식에 중요한 변경이 있을 경우,\n                  귀하의 계정에 지정된 기본 이메일 주소로 통지를 보내고, 애플리케이션에 눈에 띄는 공지를 게시하며, 및/또는 개인 정보를\n                  업데이트할 것입니다. 이러한 수정 사항이 발효된 후 애플리케이션 및/또는 제공된 서비스를 계속 사용함으로써 귀하는:\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "ul",
                                    { staticClass: "list-style-lowerAlpha" },
                                    [
                                      _c("li", [
                                        _vm._v(
                                          "수정된 개인정보 보호 정책을 인지하고;"
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("li", [
                                        _vm._v(
                                          "그 정책을 준수하고 그에 따라 귀속되는 데 동의합니다."
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "go-section",
                                  attrs: { id: "pp-s8-ko" },
                                },
                                [
                                  _c("h2", [_vm._v("연락처 정보")]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                  Goover는 이 개인정보 보호 성명에 대한 귀하의 질문이나 의견을 환영합니다. Goover가 이 성명을 준수하지 않았다고 생각되면,\n                  다음 주소로 Goover에 연락하십시오.\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "go-table-wrap" }, [
                                    _c("table", { staticClass: "go-table" }, [
                                      _c("tbody", [
                                        _c("tr", [
                                          _c("th", [_vm._v("이메일 주소")]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _c("a", [
                                              _vm._v("contact@goover.ai"),
                                            ]),
                                          ]),
                                        ]),
                                        _vm._v(" "),
                                        _c("tr", [
                                          _c("th", [_vm._v("유효일")]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              "2022년 12월 5일부터 적용됩니다."
                                            ),
                                          ]),
                                        ]),
                                      ]),
                                    ]),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn go-btn-default",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: { click: _vm.handleConfirm },
                    },
                    [_vm._v("확인")]
                  ),
                ]),
              ]),
            ]
          ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("div", { staticClass: "modal-title" }, [_vm._v("개인정보처리방침")]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn go-btn-icon close",
          attrs: { type: "button", "data-dismiss": "modal" },
        },
        [_c("i", { staticClass: "go-icon-24 go-icon-close" })]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }